module.exports = __webpack_public_path__ + "static/media/icon-download.98d65504.svg";